<!-- <!--<app-page>-->
-->
<!-- <!--  <app-header title="Create Project">-->
-->
<!-- <!--    &lt;!&ndash; <app-header-action-buttons>-->
-->
<!-- <!--      <ng-template appHeaderFilterBar>-->
-->
<!-- <!--        <app-input-search-bar-->
-->
<!-- <!--          (valueChangeEvent)="onSearchValueChange($event)"-->
-->
<!-- <!--          [clearFilterSubject]="clearFilterSubject"-->
-->
<!-- <!--          placeholder="Search users"-->
-->

<!-- <!--        >-->
-->
<!-- <!--        </app-input-search-bar>-->
-->
<!-- <!--      </ng-template>-->
-->
<!-- <!--    </app-header-action-buttons> &ndash;&gt;-->
-->
<!-- <!--  </app-header>-->
-->

<!-- <!--  &lt;!&ndash;    <app-page-content-card [transparent]="true" [noResults]="false">&ndash;&gt;-->
-->
<!-- <!--  <ng-template appPageContent>-->
-->
<!-- <!--    &lt;!&ndash; <ng-container *ngIf="project$ | async as project;">-->
-->
<!-- <!--                <app-project-item-->
-->
<!-- <!--                    *ngFor="let project of project; trackBy: trackByProject"-->
-->
<!-- <!--                    [project]="project"-->
-->
<!-- <!--                    (archiveProject)="onArchiveProject($event)"-->
-->
<!-- <!--                    (deleteProject)="onDeleteProject($event)"-->
-->
<!-- <!--                ></app-project-item>-->
-->
<!-- <!--            </ng-container> &ndash;&gt;-->
-->

<!-- <!--    details!!!-->
-->
<!-- <!--  </ng-template>-->
-->

<!-- <!--  <ng-template appPageContentNoResults>-->
-->
<!-- <!--    no results-->
-->
<!-- <!--    &lt;!&ndash; <app-no-results-->
-->
<!-- <!--            (addNewItemClickEvent)="currentSearchFilterValue?.length ? postIndustry(currentSearchFilterValue) : onAddNewItem()"-->
-->
<!-- <!--            (clearFiltersClickEvent)="onClearFilters()"-->
-->
<!-- <!--            [showClearFiltersButton]="currentSearchFilterValue?.length"-->
-->
<!-- <!--            [addItemName]="currentSearchFilterValue"-->
-->
<!-- <!--            size="xl"-->
-->
<!-- <!--            addItemText="Add industry"-->
-->
<!-- <!--            message="No industries found"-->
-->

<!-- <!--          ></app-no-results> &ndash;&gt;-->
-->
<!-- <!--  </ng-template>-->
-->
<!-- <!--  &lt;!&ndash;    </app-page-content-card>&ndash;&gt;-->
-->
<!-- <!--</app-page>-->
-->
